import React, { cloneElement } from 'react';
import {
    List, Filter, TextInput, BooleanInput, Datagrid, TextField, EmailField, useListContext,
    DeleteButton, TopToolbar, CreateButton, ExportButton, usePermissions, useRefresh, sanitizeListRestProps
} from 'react-admin';

const ActionButtons = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
        record,
    } = useListContext();

    return (
        <TopToolbar className="mb-3" {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} record={record} />
            <ExportButton />
        </TopToolbar>
    );
}

const ContactFilter = (props) => (
    <Filter {...props}>
        <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Name</h6>} source="display_name" fullWidth variant="outlined" alwaysOn />
        <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Email</h6>} source="email" fullWidth variant="outlined" />
        <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Phone</h6>} source="phone" fullWidth variant="outlined" />
    </Filter>
);

const ContactList = props => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    const contactDeleteButton = isAdmin ? (<DeleteButton redirect={toRedirect} />) : '';

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Contacts</h3>
            <List {...props} title=" " filters={<ContactFilter />} actions={<ActionButtons />} bulkActionButtons={false}>
                <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                    <TextField source="display_name" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name </h6>} />
                    <TextField source="phone" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Phone </h6>} />
                    <EmailField source="email" className="px-3 text-lowercase" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Email </h6>} />
                    {contactDeleteButton}
                </Datagrid>
            </List>
        </>
    )
};

export default ContactList;
